<div class="dashboard-container container-fluid px-0 d-flex flex-column min-vh-100">
  <div class="row g-0 vh-100 overflow-hidden">
    <div
      v-if="!is_mobile"
      class="col-auto sidebar-wrapper d-flex flex-column flex-shrink-0 vh-100 overflow-hidden"
      :class="{ 'sidebar-collapsed': sidebar_collapsed }"
    >
      <PropertySidebar
        v-if="sidebar_active_property"
        :active_property="sidebar_active_property"
        :properties="sidebar_tiles"
        :active_item="sidebar_active_item"
        :can_view_portfolio="sidebar_can_view_portfolio"
        @switch-property="open_sidebar_property"
        @go-back="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
      />
      <PortfolioSidebar
        v-else
        :tiles="sidebar_tiles"
        @tile-clicked="open_sidebar_property"
        @global-menu-selected="open_sidebar_portfolio"
        @property-menu-selected="open_sidebar_property_menu"
        @global-selected="open_sidebar_portfolio"
      />
    </div>

    <div v-if="is_mobile && mobile_sidebar_open" class="mobile-sidebar-overlay position-fixed d-flex align-items-stretch top-0 bottom-0 start-0 end-0" @click.self="mobile_sidebar_open = false">
      <div class="mobile-sidebar-panel h-100 overflow-hidden text-dark">
        <PropertySidebar
          v-if="sidebar_active_property"
          :active_property="sidebar_active_property"
          :properties="sidebar_tiles"
          :active_item="sidebar_active_item"
          :can_view_portfolio="sidebar_can_view_portfolio"
          @switch-property="open_sidebar_property"
          @go-back="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn btn btn-sm bg-white border text-dark" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PropertySidebar>
        <PortfolioSidebar
          v-else
          :tiles="sidebar_tiles"
          @tile-clicked="open_sidebar_property"
          @global-menu-selected="open_sidebar_portfolio"
          @property-menu-selected="open_sidebar_property_menu"
          @global-selected="open_sidebar_portfolio"
        >
          <template #sidebar-header-actions>
            <button class="sidebar-close-btn btn btn-sm bg-white border text-dark" @click="mobile_sidebar_open = false" aria-label="Close sidebar">
              <i class="bi bi-x-lg"></i>
            </button>
          </template>
        </PortfolioSidebar>
      </div>
    </div>

    <button v-if="!is_mobile" class="sidebar-collapse-btn btn btn-sm border bg-white text-dark translate-middle-x" @click="sidebar_collapsed = !sidebar_collapsed">
      <i :class="sidebar_collapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
    </button>

    <div class="col vh-100 d-flex flex-column overflow-hidden no-scrollbar edit-profile-shell">
    <HeaderSection 
        :breadcrumb="breadcrumb"
        @breadcrumb-click="handleBreadcrumbClick"
        @toggle-mobile-sidebar="toggle_mobile_sidebar"
    />

<div class="container-fluid p-0 edit-profile-page flex-grow-1 min-h-0 d-flex flex-column">

    <div v-if="form_error" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
        <div class="toast show align-items-center text-white border-0 shadow-lg auth-toast auth-toast-error" role="alert">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0 fs-6" aria-hidden="true">
                    <i class="bi bi-exclamation-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ form_error }}</div>
                <button type="button" class="btn-close btn-close-white ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_form_error"></button>
            </div>
        </div>
    </div>

    <!-- MAIN -->
    <section class="container-xl px-3 py-4 sp-edit-page w-100 mx-auto text-dark">

        <p class="aic-page-eyebrow text-uppercase fw-bold mb-2 text-warning">{{ is_managed_user_edit ? "User management" : "Account settings" }}</p>

        <form class="card shadow-sm rounded-4 sp-edit-card overflow-hidden" novalidate @submit.prevent="saveProfile">

            <!-- HEADER -->
            <div class="px-3 px-md-4 py-4 d-flex align-items-center gap-3 border-bottom">
                <div class="sp-avatar-lg d-inline-flex align-items-center justify-content-center flex-shrink-0 user-select-none fw-bold text-dark bg-warning rounded-4 fs-4">{{ avatar_initials }}</div>
                <div class="flex-grow-1 min-w-0">
                    <h1 class="fs-4 fw-bold m-0 mb-1 text-dark">{{ page_title }}</h1>
                    <p class="text-sm m-0 text-secondary lh-base">{{ page_description }}</p>
                </div>
            </div>

            <div v-if="is_loading" class="text-sm d-flex flex-column align-items-center justify-content-center text-center py-5 px-3 text-dark">
                <div class="spinner-border sp-spinner text-warning" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>

            <div v-else class="px-3 px-md-4">

                <!-- PERSONAL DETAILS -->
                <div class="sp-edit-section d-grid py-4 px-0">
                    <div class="sp-edit-section-intro">
                        <h2 class="sp-card-title fs-6 fw-bold mt-0 mb-1 mx-0 text-dark">Personal details</h2>
                        <p class="text-sm m-0 text-secondary lh-base">Name and contact information shown across the platform.</p>
                    </div>

                    <div class="row g-3">
                        <div class="col-md-6">
                            <label for="edit-profile-first-name" class="text-sm d-block fw-semibold mb-2 text-dark">First name</label>
                            <input
                                id="edit-profile-first-name"
                                ref="first_name_input"
                                type="text"
                                :class="['form-control sp-input', { 'is-invalid': field_errors.first_name }]"
                                placeholder="Enter first name"
                                v-model="form.first_name"
                                autocomplete="given-name"
                                :aria-invalid="field_errors.first_name ? 'true' : 'false'"
                                :aria-describedby="field_errors.first_name ? 'edit-profile-first-name-error' : null"
                                required
                                @input="validate_field('first_name', false)"
                                @blur="validate_field('first_name')"
                            >
                            <div v-if="field_errors.first_name" id="edit-profile-first-name-error" class="text-xs fw-medium mt-1 text-danger">{{ field_errors.first_name }}</div>
                        </div>

                        <div class="col-md-6">
                            <label for="edit-profile-last-name" class="text-sm d-block fw-semibold mb-2 text-dark">Last name</label>
                            <input
                                id="edit-profile-last-name"
                                ref="last_name_input"
                                type="text"
                                :class="['form-control sp-input', { 'is-invalid': field_errors.last_name }]"
                                placeholder="Enter last name"
                                v-model="form.last_name"
                                autocomplete="family-name"
                                :aria-invalid="field_errors.last_name ? 'true' : 'false'"
                                :aria-describedby="field_errors.last_name ? 'edit-profile-last-name-error' : null"
                                required
                                @input="validate_field('last_name', false)"
                                @blur="validate_field('last_name')"
                            >
                            <div v-if="field_errors.last_name" id="edit-profile-last-name-error" class="text-xs fw-medium mt-1 text-danger">{{ field_errors.last_name }}</div>
                        </div>

                        <div class="col-md-6">
                            <label for="edit-profile-email" class="text-sm d-block fw-semibold mb-2 text-dark">Email address</label>
                            <div class="sp-input-icon position-relative">
                                <i class="bi bi-envelope position-absolute top-50 translate-middle-y pointer-events-none" aria-hidden="true"></i>
                                <input
                                    id="edit-profile-email"
                                    type="email"
                                    class="form-control sp-input"
                                    placeholder="name@example.com"
                                    v-model="form.email"
                                    aria-describedby="edit-profile-email-hint"
                                    readonly
                                >
                            </div>
                            <div id="edit-profile-email-hint" class="sp-field-hint d-flex align-items-center gap-1 mt-1 text-secondary text-xs"><i class="bi bi-lock"></i> Email can't be changed here.</div>
                        </div>

                        <div class="col-md-6">
                            <label for="edit-profile-phone" class="text-sm d-block fw-semibold mb-2 text-dark">Phone number</label>
                            <div class="sp-input-icon position-relative">
                                <i class="bi bi-telephone position-absolute top-50 translate-middle-y pointer-events-none" aria-hidden="true"></i>
                                <input
                                    id="edit-profile-phone"
                                    ref="phone_input"
                                    type="tel"
                                    name="phone"
                                    pattern="[0-9]{10}"
                                    inputmode="numeric"
                                    placeholder="0123456789"
                                    :class="['form-control sp-input', { 'is-invalid': field_errors.phone }]"
                                    v-model="form.phone"
                                    autocomplete="tel-national"
                                    :aria-invalid="field_errors.phone ? 'true' : 'false'"
                                    :aria-describedby="field_errors.phone ? 'edit-profile-phone-error' : null"
                                    required
                                    @input="validate_field('phone', false)"
                                    @blur="validate_field('phone')"
                                >
                            </div>
                            <div v-if="field_errors.phone" id="edit-profile-phone-error" class="text-xs fw-medium mt-1 text-danger">{{ field_errors.phone }}</div>
                        </div>
                    </div>
                </div>

                <!-- SESSION ACCESS (managed users only) -->
                <div v-if="is_managed_user_edit" class="sp-edit-section d-grid py-4 px-0">
                    <div class="sp-edit-section-intro">
                        <h2 class="sp-card-title fs-6 fw-bold mt-0 mb-1 mx-0 text-dark">Session period</h2>
                        <p class="text-sm m-0 text-secondary lh-base">Control whether this user follows the default timeout, never expires, or uses a custom duration.</p>
                    </div>

                    <div class="row g-3">
                        <div class="col-md-7">
                            <label class="text-sm d-block fw-semibold mb-2 text-dark">Timeout mode</label>
                            <div class="btn-group w-100" role="group" aria-label="Session period">
                                <button
                                    v-for="option in session_policy_options"
                                    :key="option.value"
                                    type="button"
                                    :class="['btn text-nowrap', form.session_policy === option.value ? 'btn-warning text-dark' : 'btn-light border']"
                                    :aria-pressed="form.session_policy === option.value"
                                    @click="form.session_policy = option.value; handle_session_policy_change()"
                                >
                                    {{ option.label }}
                                </button>
                            </div>
                        </div>

                        <div v-if="form.session_policy === custom_session_policy" class="col-md-5">
                            <label for="edit-profile-session-minutes" class="text-sm d-block fw-semibold mb-2 text-dark">Custom duration</label>
                            <div class="input-group">
                                <input
                                    id="edit-profile-session-minutes"
                                    ref="session_timeout_input"
                                    v-model.number="form.session_timeout_minutes"
                                    type="number"
                                    min="1"
                                    step="1"
                                    :class="['form-control sp-input', { 'is-invalid': field_errors.session_timeout_minutes }]"
                                    :aria-invalid="field_errors.session_timeout_minutes ? 'true' : 'false'"
                                    :aria-describedby="field_errors.session_timeout_minutes ? 'edit-profile-session-minutes-error' : null"
                                    @input="validate_field('session_timeout_minutes', false)"
                                    @blur="validate_field('session_timeout_minutes')"
                                >
                                <span class="input-group-text">minutes</span>
                            </div>
                            <div v-if="field_errors.session_timeout_minutes" id="edit-profile-session-minutes-error" class="text-xs fw-medium mt-1 text-danger">{{ field_errors.session_timeout_minutes }}</div>
                        </div>
                    </div>
                </div>

                <!-- SITE ACCESS (managed users only) -->
                <div v-if="is_managed_user_edit" class="sp-edit-section d-grid py-4 px-0">
                    <div class="sp-edit-section-intro">
                        <h2 class="sp-card-title fs-6 fw-bold mt-0 mb-1 mx-0 text-dark">Site access</h2>
                        <p class="text-sm m-0 text-secondary lh-base">Choose which sites this user can view and manage.</p>
                    </div>

                    <div>
                        <div class="sp-label-row d-flex align-items-center justify-content-between gap-3 mb-2">
                            <span class="text-sm d-block fw-semibold mb-0 text-dark">Assigned sites</span>
                            <span class="badge rounded-pill border fw-semibold bg-warning-subtle text-warning-emphasis border-warning-subtle d-inline-flex align-items-center text-nowrap gap-1 py-1 px-2 lh-sm">{{ selected_property_count }} selected</span>
                        </div>

                        <div v-if="is_loading_properties" class="sp-empty-box d-flex align-items-center gap-2 p-3 text-secondary bg-body-tertiary">
                            <span class="spinner-border spinner-border-sm sp-spinner text-warning" aria-hidden="true"></span> Loading sites...
                        </div>

                        <div v-else-if="!property_options.length" class="sp-empty-box d-flex align-items-center gap-2 p-3 text-secondary bg-body-tertiary">
                            No active sites available.
                        </div>

                        <div v-else class="sp-site-picker d-grid gap-2" :class="{ 'is-invalid': field_errors.property_ids }">
                            <button
                                v-for="property in property_options"
                                :key="property.id"
                                type="button"
                                ref="propertyButtons"
                                class="sp-site-option d-flex align-items-center text-start gap-2 py-2 px-3 text-dark"
                                :class="{ 'is-selected': is_property_selected(property.id) }"
                                :aria-pressed="is_property_selected(property.id)"
                                :aria-invalid="field_errors.property_ids ? 'true' : 'false'"
                                @click="toggle_property(property.id)"
                            >
                                <span class="sp-site-option-check d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded-1" aria-hidden="true">
                                    <i v-if="is_property_selected(property.id)" class="bi bi-check-lg"></i>
                                </span>
                                <i class="bi bi-building sp-site-option-icon text-secondary" aria-hidden="true"></i>
                                <span class="text-truncate">{{ property.name }}</span>
                            </button>
                        </div>
                        <div v-if="field_errors.property_ids" class="text-xs fw-medium mt-1 text-danger">{{ field_errors.property_ids }}</div>
                    </div>
                </div>
            </div>

            <!-- FOOTER -->
            <div class="sp-edit-footer px-3 px-md-4 py-3 d-flex justify-content-end gap-2 border-top bg-body-tertiary">
                <button type="button" class="btn d-inline-flex align-items-center justify-content-center gap-2 text-sm btn-light border text-nowrap text-decoration-none" @click="cancelEdit">
                    Cancel
                </button>
                <button type="submit" class="btn d-inline-flex align-items-center justify-content-center gap-2 text-sm btn-primary text-nowrap text-decoration-none text-dark" :disabled="is_saving || is_loading">
                    <span v-if="is_saving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <i v-else class="bi bi-check2"></i>
                    <span>{{ is_saving ? "Saving..." : "Save changes" }}</span>
                </button>
            </div>
        </form>

    </section>

</div>
    </div>
  </div>
</div>
